/**
 * Created by Mark on 18/04/2017.
 */



import ApplicationServices from './base-service.js';
import Constants from '../constants/students.js';
import Actions from '../actions/default.js';

class StudentsService {

    constructor(){
        this.isAuthenticated = false;
        this.timeout = null;
    }

    deleteStudent(uid){
        return ApplicationServices.call(Constants.DELETE_STUDENT , {uid:uid}).then(function(response){
            return response;
        });
    }
    
    editStudent(uid , firstName , lastName , password  , passChanged , classes){
        return ApplicationServices.call(Constants.EDIT_STUDENT , {password:password , classes:classes , uid:uid , firstName:firstName , lastName:lastName , passChanged:passChanged}).then(function(response){
            return response;
        });
    }

    hasConflictingStudents(className){
        return ApplicationServices.call(Constants.GET_CONFLICTING_STUDENTS , {className:className}).then(function(response){
            return response['isValid'];
        });
    }

    realDeleteStudent(uid){
        return ApplicationServices.call(Constants.REAL_DELETE_STUDENT , {uid:uid}).then(function(response){
            return response;
        });
    }

    getDeletedStudents(){
        return ApplicationServices.call(Constants.GET_ALL_DELETED_STUDENTS , {}).then(function(response){
            Actions.update(Constants.UPDATE_ALL_DELETED_STUDENTS , response.students);
        });
    }

    getAllViewableStudents(){
        return ApplicationServices.call(Constants.GET_ALL_VIEWABLE_STUDENTS , {}).then(function(response){
            Actions.update(Constants.UPDATE_ALL_VIEWABLE_STUDENTS , response.students);
        });
    }

    getAll(){
        return ApplicationServices.call(Constants.GET_ALL_STUDENTS , {}).then(function(response){
            Actions.update(Constants.UPDATE_ALL_STUDENTS , response.students);
        });
    }

    getStudentCount(){
        return ApplicationServices.call(Constants.GET_STUDENT_ACCOUNT_COUNT , {}).then(function(response){
            return response.total;
        });
    }

    getAllStudentsInClass(classID){

        return ApplicationServices.call(Constants.GET_STUDENTS_IN_CLASS , {classID:classID}).then(function(response){
            Actions.update(Constants.UPDATE_STUDENTS_IN_CLASSES , response.students);
        });
    }

    getStudent(studentID){
        return ApplicationServices.call(Constants.GET_STUDENT , {studentID:studentID}).then(function(response){
            Actions.update(Constants.UPDATE_STUDENT , response.student);
        });
    }

    getStudentLanguages(studentID){
        return ApplicationServices.call(Constants.GET_STUDENT_LANGUAGES , {studentID:studentID}).then(function(response){
            Actions.update(Constants.UPDATE_STUDENT_LANGUAGES , response.languages);
        });
    }

    getStudentRecent(studentID , from , to , languageValue){
        return ApplicationServices.call(Constants.GET_STUDENT_RECENT , {languageID:languageValue , from:from , to:to , studentID:studentID}).then(function(response){
            Actions.update(Constants.UPDATE_STUDENT_RECENT , response.activity);
        });
    }

    getExistingStudents(studentNames){
        return ApplicationServices.call(Constants.EXISITNG_ACCOUNT_STUDENTS , {students:studentNames}).then(function(response){
           return response.existingStudents;
        });
    }

    getProgressReportData(studentID  , from , to , languageValue){
        return ApplicationServices.call(Constants.GET_STUDENT_PROGRESS , {languageID:languageValue , from:from , to:to , studentID:studentID})
    }


}


export default new StudentsService();


// WEBPACK FOOTER //
// ./src/services/student-services.js